import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable/types'
import { TypePosition } from '../../../components/TypePosition/types/TypePosition'
import { YesNoBadge } from '../../../components/YesNoBadge'


export const getColumnsConfig = (): TableColumn<TypePosition>[] => [
  {
    key: 'typePositionId',
    title: 'ID'
  },
  {
    key: 'typePositionCode',
    title: 'CÓDIGO'
  },
  {
    key: 'typePositionDescription',
    title: 'DESCRIPCIÓN'
  },
  {
    key: 'considerInventory',
    title: 'INFORMA INVENTARIO',    
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  },
  {
    key: 'requireZone',
    title: 'REQUIERE ZONA',
    render: (value: unknown) => <YesNoBadge value={value as boolean} />
  }
]
